import { FC, SVGAttributes } from "react";

const InfoItalicSmall: FC<
  SVGAttributes<SVGSVGElement> & { color?: string }
> = ({ color = "#FFF", ...props }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41552 4.3977C6.62235 4.3977 6.79921 4.32984 6.94611 4.19412C7.09301 4.05841 7.16667 3.89373 7.16667 3.7005C7.16667 3.5081 7.09301 3.3426 6.94611 3.20564C6.79963 3.06827 6.62235 3 6.41552 3C6.20911 3 6.031 3.06827 5.88285 3.20564C5.73596 3.3426 5.66105 3.5081 5.66105 3.7005C5.66105 3.89332 5.73554 4.05841 5.88285 4.19412C6.031 4.32984 6.20911 4.3977 6.41552 4.3977ZM6.39638 8.9218C6.54744 8.86966 6.74886 8.79436 7.00187 8.69506L7.08635 8.35287C7.04224 8.37315 6.97233 8.39673 6.87578 8.42321C6.7784 8.44969 6.69226 8.46335 6.61527 8.46335C6.45214 8.46335 6.33687 8.43645 6.27112 8.38308C6.20454 8.3297 6.17166 8.22916 6.17166 8.08186C6.17166 8.02352 6.18165 7.93663 6.20204 7.82284C6.22285 7.70905 6.24573 7.60727 6.27154 7.51831L6.58656 6.40942C6.61735 6.30722 6.63858 6.19592 6.64981 6.07386C6.66105 5.95221 6.66687 5.86697 6.66687 5.81856C6.66687 5.5852 6.58406 5.39528 6.41968 5.24922C6.25447 5.10358 6.01977 5.02993 5.71556 5.02993C5.54702 5.02993 5.36808 5.05972 5.17873 5.12013C4.98939 5.17971 4.79089 5.25171 4.58365 5.3357L4.5 5.6783C4.56076 5.65513 4.63483 5.63154 4.72014 5.60548C4.80628 5.58024 4.89035 5.56824 4.97191 5.56824C5.13878 5.56824 5.25073 5.59555 5.31024 5.6514C5.36891 5.70726 5.39846 5.80657 5.39846 5.94807C5.39846 6.02752 5.38931 6.11482 5.37016 6.20999C5.35102 6.30432 5.32688 6.4057 5.299 6.51245L4.98231 7.62465C4.95443 7.74174 4.93404 7.84601 4.92114 7.93869C4.90866 8.03138 4.90241 8.12241 4.90241 8.21136C4.90241 8.44018 4.98689 8.62844 5.15668 8.77698C5.32647 8.92552 5.56492 9 5.8712 9C6.07054 9 6.24573 8.97393 6.39638 8.9218Z"
        fill={color}
      />
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoItalicSmall;
